module.exports = __webpack_public_path__ + "static/pic18-818b3919810ff7fc907980859cad3fac.jpg";